import api from 'api';

export default async ({
  asPath,
  fetchLimitedData = false,
  reduxStore,
  req
}) => {
  let user;
  let userId;
  if (asPath.indexOf('/profile') === 0) {
    const state = reduxStore.getState();
    user = state.user;
    userId = state.user.id;
  } else {
    userId = parseInt(asPath.split('/')[2], 10);
  }

  const headers = req ? { Cookie: req.headers.cookie } : {};

  let users;
  if (fetchLimitedData) {
    users = await api.get(`/admin/users-user?id=${userId}`, { headers });
  } else {
    users = await api.get(`/admin/users?id=${userId}`, {
      headers
    });
  }

  return { ...users.data.users[0], ...user };
};
